import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useAuth } from "../context/AuthContext";

export const NAV_LABELS = {
  home: "Home",
  services: "Services",
  software: "Software",
  faq: "FAQ",
  about: "About",
  contact: "Contact",
};

export default function PublicHeader({ isHomePage = false }) {
  const { redirectToLogin } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleNavClick = (e, key) => {
    if (key === 'software') return; // let the default href="/software" happen

    if (isHomePage) {
      e.preventDefault();
      setMobileMenuOpen(false);
      if (key === 'home') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      const element = document.getElementById(key);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-[#E2E8F0] shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <a href={isHomePage ? "#home" : "/"} onClick={(e) => handleNavClick(e, 'home')} className="flex items-center gap-3 group">
            <span className="text-[#145886] font-serif font-bold text-xl group-hover:text-[#55B848] transition-colors">
              CA Ronak Patel
            </span>
          </a>
          <nav className="hidden md:flex items-center gap-4">
            {Object.entries(NAV_LABELS).map(([key, label]) => {
              const href = key === 'software' ? '/software' : (isHomePage ? `#${key}` : `/#${key}`);
              return (
                <a
                  key={key}
                  href={href}
                  onClick={(e) => handleNavClick(e, key)}
                  className="text-xs font-bold uppercase tracking-widest text-[#475569] hover:text-[#145886] transition-all relative group"
                  data-testid={`nav-${key}`}
                >
                  {label}
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#F37920] transition-all group-hover:w-full"></span>
                </a>
              );
            })}
          </nav>
          <div className="flex items-center gap-3">
            <button
              onClick={redirectToLogin}
              className="hidden sm:block bg-[#145886] text-white px-6 py-2 rounded text-xs font-bold uppercase tracking-widest hover:bg-[#0e4068] transition-all hover:shadow-lg transform hover:-translate-y-0.5"
              data-testid="header-login-btn"
            >
              Login
            </button>
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 text-[#475569] hover:text-[#145886]"
              data-testid="mobile-menu-toggle"
            >
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {mobileMenuOpen
                  ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                }
              </svg>
            </button>
          </div>
        </div>
        <AnimatePresence>
          {mobileMenuOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              className="md:hidden border-t border-[#E2E8F0] bg-white/95 backdrop-blur-lg"
              data-testid="mobile-nav-menu"
            >
              <div className="flex flex-col px-6 py-4 gap-3">
                {Object.entries(NAV_LABELS).map(([key, label]) => {
                  const href = key === 'software' ? '/software' : (isHomePage ? `#${key}` : `/#${key}`);
                  return (
                    <a
                      key={key}
                      href={href}
                      onClick={(e) => handleNavClick(e, key)}
                      className="text-left text-sm font-bold uppercase tracking-widest text-[#475569] hover:text-[#145886] transition-colors py-2 block"
                    >
                      {label}
                    </a>
                  );
                })}
                <div className="pt-2 mt-2 border-t border-[#E2E8F0]">
                  <button
                    onClick={redirectToLogin}
                    className="w-full bg-[#145886] text-white px-6 py-3 rounded text-sm font-bold uppercase tracking-widest hover:bg-[#0e4068] transition-colors flex items-center justify-center gap-2"
                  >
                    Login
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </button>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </header>
    </>
  );
}
